// extracted by mini-css-extract-plugin
export default {"errorMessage":"ValidationLabel_errorMessage__XeY5R","asBigText":"ValidationLabel_asBigText__RRMHx","centered":"ValidationLabel_centered__Ze4fq"};